import { STORES, openStore, AppleIcon, PlayIcon } from "@/lib/stores";

/** The two store buttons used everywhere a "Download LuxeRay App" action lives. */
export default function StoreButtons({ size = "lg", testid = "store" }) {
  const pad = size === "lg" ? "px-8 py-4 text-sm" : "px-5 py-3 text-xs";
  return (
    <div className="flex flex-wrap gap-3 items-center" data-testid={`${testid}-buttons`}>
      {STORES.map((s, i) => (
        <button
          key={s.id}
          type="button"
          onClick={() => openStore(s)}
          aria-disabled={!s.url}
          title={s.url ? s.url : "Launching soon"}
          className={`${pad} rounded-xl font-mono-lbl uppercase tracking-wider font-bold transition-colors flex items-center gap-3 ${
            i === 0
              ? "bg-[#FF2E2E] hover:bg-[#E01F1F] text-white shadow-lg shadow-black/30"
              : "bg-white/10 hover:bg-white/20 border border-white/20 text-white"
          }`}
          data-testid={`${testid}-${s.id}-btn`}
          data-live={s.url ? "true" : "false"}
        >
          {s.id === "ios" ? <AppleIcon /> : <PlayIcon />}
          <span>
            {s.label}
            {!s.url && <span className="block text-[9px] opacity-70 normal-case tracking-normal font-normal">Launching soon</span>}
          </span>
        </button>
      ))}
    </div>
  );
}
